import script from "./MainSiteLogoWhite.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSiteLogoWhite.vue?vue&type=script&setup=true&lang=js"

import "./MainSiteLogoWhite.vue?vue&type=style&index=0&id=18d61796&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d61796"]])

export default __exports__